// Page-specific styles for the PhantomBetPage. Default screen renders the
// two primary action buttons + a recommendation note. Opt-out screen
// renders strong warnings, a checkbox row, and a typed-phrase input.
// Shared form atoms (label, button, message) live in
// ../../components/onboarding/onboarding-form.styles.ts.

import type { CSSProperties } from "react";

export const recommendationCallout: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-2)",
  padding: "16px 18px",
  background: "var(--sz-amber-glow)",
  border: "1px solid var(--sz-amber-dim)",
  borderRadius: "var(--sz-radius-md)",
};

export const calloutEyebrow: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "var(--sz-amber-text)",
};

export const calloutBody: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-text-secondary)",
  lineHeight: 1.55,
};

export const warningBlock: CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "var(--sz-space-2)",
  padding: "16px 18px",
  background: "var(--sz-warning-dim)",
  border: "1px solid var(--sz-warning)",
  borderRadius: "var(--sz-radius-md)",
};

export const warningEyebrow: CSSProperties = {
  fontFamily: "var(--sz-font-mono)",
  fontSize: "var(--sz-mono-xs)",
  letterSpacing: "2px",
  textTransform: "uppercase",
  color: "var(--sz-warning-text)",
};

export const warningBody: CSSProperties = {
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-text-secondary)",
  lineHeight: 1.55,
};

export const warningList: CSSProperties = {
  margin: 0,
  paddingLeft: "20px",
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  color: "var(--sz-text-secondary)",
  lineHeight: 1.65,
  display: "flex",
  flexDirection: "column",
  gap: "6px",
};

export const dangerBtn: CSSProperties = {
  background: "transparent",
  color: "var(--sz-danger-text)",
  border: "1px solid var(--sz-danger)",
  padding: "12px 18px",
  fontFamily: "var(--sz-font-body)",
  fontSize: "var(--sz-body-sm)",
  letterSpacing: "0.5px",
  borderRadius: "var(--sz-radius-md)",
};
